<section class="hero-split-layout" [ngStyle]="heroContainerStyles()" [attr.data-theme]="block().data.theme">
    @if (block().data.includeImage && block().data.imagePosition === 'left') {
        <div class="hero-split-layout__image-container">
            <img
                class="hero-split-layout__image"
                [ngClass]="block().data.imageFillContainer ? 'hero-split-layout__image-fill' : ''"
                [src]="block().data.image"
                [alt]="block().data.imageAltText" />
        </div>
    }

    <div class="hero-split-layout__content" [attr.data-text-color-override]="block().data.contentTextColor">
        <h1
            class="hero-split-layout__heading"
            [attr.data-has-custom-heading-typography]="hasCustomHeadingTypography() || null">
            {{ block().data.heading }}
        </h1>
        @if (block().data.description) {
            <div
                class="hero-split-layout__description"
                [innerHTML]="block().data.description"
                [attr.data-has-custom-description-typography]="hasCustomDescriptionTypography() || null"></div>
        }
    </div>

    @if (block().data.includeImage && block().data.imagePosition === 'right') {
        <div class="hero-split-layout__image-container">
            <img
                class="hero-split-layout__image"
                [ngClass]="block().data.imageFillContainer ? 'hero-split-layout__image-fill' : ''"
                [src]="block().data.image"
                [alt]="block().data.imageAltText" />
        </div>
    }
</section>
